module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pp-playbar"
  }, [(_vm.currentTrack && _vm.currentTrack.album && _vm.currentTrack.album.artwork) ? _c('div', {
    staticClass: "pp-playbar__artwork",
    on: {
      "click": _vm.navigateAlbum
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.currentTrack.album.artwork
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.currentTrack) ? _c('div', {
    staticClass: "pp-playbar__now-playing",
    on: {
      "click": _vm.navigateAlbum
    }
  }, [_c('div', {
    staticClass: "pp-playbar__now-playing__track",
    style: ({
      width: _vm.nowPlayingSize,
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    })
  }, [_vm._v("\n            " + _vm._s(_vm.currentTrack.title) + "\n        ")]), _vm._v(" "), (_vm.currentTrack.album && !_vm.currentTrack.album.exclusive_id) ? _c('div', {
    staticClass: "pp-playbar__now-playing__album",
    style: ({
      width: _vm.nowPlayingSize,
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    })
  }, [_vm._v("\n            " + _vm._s(_vm.currentTrack.album.title) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.currentTrack.album && _vm.currentTrack.album.exclusive_id && _vm.currentTrack.album.artists) ? _c('div', {
    staticClass: "pp-playbar__now-playing__album",
    style: ({
      width: _vm.nowPlayingSize,
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    })
  }, [_vm._v("\n            " + _vm._s(_vm.getExclusiveArtistLine(_vm.currentTrack.album)) + "\n        ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentTrack),
      expression: "currentTrack"
    }],
    staticClass: "pp-playbar__padding"
  }), _vm._v(" "), _c('div', {
    staticClass: "pp-playbar__controls-container"
  }, [_c('div', {
    staticClass: "pp-play-controls"
  }, [_c('div', {
    staticClass: "pp-play-controls__main"
  }, [_c('ul', {
    ref: "secondaryControls",
    staticClass: "pp-play-controls__main__secondary"
  }, [_c('li', [_c('button', {
    class: {
      'pp-play-controls__button': 1,
      'pp-play-controls__button--active': _vm.controls.repeat
    },
    attrs: {
      "title": "Repeat"
    },
    on: {
      "click": _vm.toggleRepeat
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-refresh"
  })])]), _vm._v(" "), _c('li', [_c('button', {
    class: {
      'pp-play-controls__button': 1,
      'pp-play-controls__button--active': _vm.controls.shuffle
    },
    attrs: {
      "title": "Shuffle"
    },
    on: {
      "click": _vm.toggleShuffle
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-random"
  })])]), _vm._v(" "), _c('li', [_c('button', {
    ref: "toggleQueueButton",
    class: {
      'pp-play-controls__button': 1,
      'pp-play-controls__button--active': _vm.controls.showQueue
    },
    attrs: {
      "title": "Toggle queue"
    },
    on: {
      "click": _vm.toggleQuickQueue
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-indent"
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.controls.showQueue),
      expression: "controls.showQueue"
    }],
    ref: "queuePopup",
    staticClass: "pp-playbar__quickqueue"
  }, [_c('div', {
    staticClass: "pp-playbar__quickqueue__header"
  }, [_vm._v("\n                                History "), (_vm.history.length > 0) ? _c('small', [_vm._v("(" + _vm._s(_vm.history.length) + " items)")]) : _vm._e()]), _vm._v(" "), _c('mini-track-list', {
    attrs: {
      "max-rows": 2,
      "reversed": true,
      "items": _vm.history,
      "context-mode": "from-history",
      "zerostate": "Empty"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "pp-playbar__quickqueue__header"
  }, [_vm._v("\n                                Now Playing\n                            ")]), _vm._v(" "), _c('mini-track-list', {
    attrs: {
      "items": _vm.currentTrack ? [_vm.currentTrack] : [],
      "zerostate": "Not playing"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "pp-playbar__quickqueue__header"
  }, [_vm._v("\n                                Up Next "), (_vm.queue.length > 0) ? _c('small', [_vm._v("(" + _vm._s(_vm.queue.length) + " items)")]) : _vm._e()]), _vm._v(" "), _c('mini-track-list', {
    attrs: {
      "max-rows": 4,
      "items": _vm.queue,
      "context-mode": "from-queue",
      "zerostate": "Nothing in queue"
    }
  })], 1)])]), _vm._v(" "), _c('ul', {
    staticClass: "pp-play-controls__main__primary"
  }, [_c('li', [_c('button', {
    staticClass: "pp-play-controls__button pp-play-controls__button--primary",
    on: {
      "click": _vm.backward
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-backward"
  })])]), _vm._v(" "), _c('li', [_c('button', {
    staticClass: "pp-play-controls__button pp-play-controls__button--play",
    on: {
      "click": _vm.play
    }
  }, [_c('i', {
    class: {
      'fa': 1,
      'fa-fw': 1,
      'fa-play': !_vm.playing,
      'fa-pause': _vm.playing
    }
  })])]), _vm._v(" "), _c('li', [_c('button', {
    staticClass: "pp-play-controls__button pp-play-controls__button--primary",
    on: {
      "click": _vm.forward
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-forward"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "pp-play-controls__volume"
  }, [_vm._m(0), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.controls.volume),
      expression: "controls.volume"
    }],
    staticClass: "pp-seekbar",
    attrs: {
      "data-seekbar-fix": "",
      "type": "range",
      "max": "100",
      "min": "0",
      "value": "50"
    },
    domProps: {
      "value": (_vm.controls.volume)
    },
    on: {
      "__r": function($event) {
        return _vm.$set(_vm.controls, "volume", $event.target.value)
      }
    }
  }), _vm._v(" "), _vm._m(1)])]), _vm._v(" "), _c('div', {
    staticClass: "pp-play-controls__seekbar"
  }, [_c('div', {
    staticClass: "pp-play-controls__seekbar__label"
  }, [_vm._v("\n                    " + _vm._s(_vm._f("duration")(_vm.playbackPositionSeconds)) + "\n                ")]), _vm._v(" "), _c('input', {
    ref: "seekbar",
    staticClass: "pp-seekbar pp-seekbar--subtle-thumb",
    attrs: {
      "step": "0.001",
      "data-seekbar-fix": "",
      "type": "range",
      "max": "100",
      "min": "0",
      "value": "33"
    },
    domProps: {
      "value": _vm.controls.seeking ? _vm.controls.position : _vm.playbackPosition
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "pp-play-controls__seekbar__label"
  }, [_vm._v("\n                    " + _vm._s(_vm._f("duration")(_vm.playbackDuration)) + "\n                ")])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentTrack),
      expression: "currentTrack"
    }],
    staticClass: "pp-playbar__quality"
  }, [_c('div', {
    staticClass: "pp-playbar__quality__label"
  }, [_vm._v("\n            MP3\n        ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.flacInput),
      expression: "flacInput",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "pp-seekbar pp-seekbar--togglebutton",
    attrs: {
      "disabled": !_vm.enableFlac || !_vm.enableFlacTrack,
      "debug": _vm.flacInput,
      "data-seekbar-fix": "",
      "type": "range",
      "max": "1",
      "min": "0",
      "value": "1"
    },
    domProps: {
      "value": (_vm.flacInput)
    },
    on: {
      "__r": function($event) {
        _vm.flacInput = _vm._n($event.target.value)
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "pp-playbar__quality__label"
  }, [_vm._v("\n            FLAC\n        ")]), _vm._v(" "), (!_vm.enableFlac) ? _c('div', {
    staticClass: "pp-playbar__quality__disabled pp-playbar__quality__disabled--device",
    attrs: {
      "title": "To enable FLAC playback, please use a modern browser such as Chrome or Firefox."
    }
  }, [_vm._v("\n            Not supported by your device.\n        ")]) : _vm._e(), _vm._v(" "), (_vm.enableFlac && !_vm.enableFlacTrack) ? _c('div', {
    staticClass: "pp-playbar__quality__disabled pp-playbar__quality__disabled--device",
    attrs: {
      "title": "Unfortunately we don't have a copy of this track in FLAC at the yet."
    }
  }, [_vm._v("\n            Not available for this track.\n        ")]) : _vm._e()]), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentTrack && _vm.currentTrack.album && !_vm.$root.isIos),
      expression: "currentTrack && currentTrack.album && !$root.isIos"
    }],
    staticClass: "pp-playbar__button",
    attrs: {
      "href": 'https://www.pristineclassical.com/products/' + ((_vm.currentTrack && _vm.currentTrack.album) ? _vm.currentTrack.album.code.toLowerCase() : ''),
      "target": "_blank"
    }
  }, [_vm._v("\n        Buy Now\n    ")])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pp-play-controls__volume__label"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-volume-off"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pp-play-controls__volume__label"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-volume-up"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-300eaced","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PpPlaybar.vue
// module id = 123
// module chunks = 0 1